{% block swag_paypal_pos_boolean_radio %}
    <sw-radio-field
        v-model:value="castedValue"
        v-bind="$attrs"
        class="swag-paypal-pos-boolean-radio"
        :name="name"
        :options="options" />
{% endblock %}
